import ApplicationData, { AttorneyData, JudgeBasicSectionData } from 'src/dtos/applicationData'
import { aboutAttorneyPosition } from 'src/constants/application'

export const attorneyFullName = (attorney: AttorneyData) => {
  return [attorney.firstName?.trim(), attorney.lastName?.trim()].join(' ')
}

export const onlyICOCAttorneys = (app: ApplicationData) => {
  const ic = aboutAttorneyPosition[1]
  const oc = aboutAttorneyPosition[4]
  
  return app?.attorneysSection?.attorneys?.filter(att => att?.position === ic || att?.position === oc) ?? []
}

export const judgeFullName = (judgeBasic: JudgeBasicSectionData | undefined) => {
  return !!judgeBasic ? [judgeBasic.firstName?.trim(), judgeBasic.lastName?.trim()].join(' ') : 'N/A'
}

export const judgeContactFullName = (judgeBasic: JudgeBasicSectionData | undefined) => {
  return !!judgeBasic ? [judgeBasic?.contactInfo?.firstName?.trim(), judgeBasic?.contactInfo?.lastName?.trim()].join(' ') : 'N/A'
}